import axios from "axios";

export const state = {
    reportlabs: [],
};

export const getters = {
    reportlabs: state => state.reportlabs,
};

export const mutations = {
    setReportLab(reportlabs, newValue) { state.reportlabs = newValue},
};

export const actions = {
    fetchReportLab({ commit }) {
        axios.get('/reportlabs').then(res => {
            commit('setReportLab', res.data.performances)
        })
    },
    filterReportLab({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filterreportlabs";
        axios.post(url, formData).then((response) => {
            commit('setReportLab', response.data.performances)
        })
    },
};
